import { Injectable } from '@angular/core';
import { TokenAuthServiceProxy, AuthenticateModel, AuthenticateResultModel, SessionServiceProxy } from '../../shared/service-proxies/service-proxies';
import { finalize, catchError, switchAll } from 'rxjs/operators';
import { Router } from '@angular/router';
// import { UtilsService } from 'abp-ng2-module/dist/src/utils/utils.service';
// import { MessageService } from 'abp-ng2-module/dist/src/message/message.service';
// import { TokenService } from 'abp-ng2-module/dist/src/auth/token.service';
// import { LogService } from 'abp-ng2-module/dist/src/log/log.service';
import { AppConsts } from '../../shared/AppConsts';
import { UrlHelper } from '../../shared/helpers/UrlHelper';
import { NoticeComponent } from './../../app/views/partials/content/general/notice/notice.component';
import { Observable, of } from 'rxjs';
import { TokenService } from 'abp-ng2-module/dist/src/auth/token.service';
import { UtilsService } from 'abp-ng2-module/dist/src/utils/utils.service';
import { MessageService } from 'abp-ng2-module/dist/src/message/message.service';
import { LogService } from 'abp-ng2-module/dist/src/log/log.service';


@Injectable({
  providedIn: 'root'
})
export class LoginService {

  static readonly twoFactorRememberClientTokenName = 'TwoFactorRememberClientToken';

  authenticateModel: AuthenticateModel;
  authenticateResult: AuthenticateResultModel;
  rememberMe: boolean;
  isProcessing : boolean;

  constructor(
    private _tokenAuthService: TokenAuthServiceProxy,
    private _router: Router,
    private _utilsService: UtilsService,
    private _messageService: MessageService,
    private _tokenService: TokenService,
	  private _logService: LogService,
	  private _sessionService: SessionServiceProxy

  ) { 
      this.clear();
  }

  loginToServer(username: string, password: string, finallyCallback?: () => void, completedCallback?:() => void) : void {
    finallyCallback = finallyCallback || (() => { });
    completedCallback = completedCallback || (() => { });

   
    var authModel : AuthenticateModel  = {} as any;
      
    authModel.userNameOrEmailAddress = username ;
    authModel.password = password ;

    console.log(authModel);



    this._tokenAuthService
        .authenticate(authModel)
        .pipe(
          finalize(() => {
            //console.log("finallyCallback()");
            finallyCallback();
           
          }))
          .subscribe((result: AuthenticateResultModel) => {
            console.log("Login tamamdir!");
            console.log(result);
            this.processAuthenticateResult(result);
            //let str = JSON.stringify(result);
            //console.log(str);
            completedCallback();
          }, (err) => {
            //abp.message.error(err);
            //abp.notify.success("dasda");
            //alert('Login hata!!');
            console.log("ERROR VAR!", err);
            
            
          }, () =>{
            console.log("completedCallback()");
           
          }
        );
        
  }


  private processAuthenticateResult(authenticateResult: AuthenticateResultModel) {
    this.authenticateResult = authenticateResult;
    
    

    if (authenticateResult.accessToken) {
        // Successfully logged in
        this.login(
            authenticateResult.accessToken,
            authenticateResult.encryptedAccessToken,
            authenticateResult.expireInSeconds,
            this.rememberMe);
  
    } else {
        // Unexpected result!
  
        this._logService.warn('Unexpected authenticateResult!');
        this._router.navigate(['login']);
    }
  }
  
  private login(accessToken: string, encryptedAccessToken: string, expireInSeconds: number, rememberMe?: boolean): void {
  
    const tokenExpireDate = rememberMe ? (new Date(new Date().getTime() + 1000 * expireInSeconds)) : undefined;
  
    this._tokenService.setToken(
        accessToken,
        tokenExpireDate
    );
  
    this._utilsService.setCookieValue(
        AppConsts.authorization.encryptedAuthTokenName,
        encryptedAccessToken,
        tokenExpireDate,
        abp.appPath
	);


  
    let initialUrl = UrlHelper.initialUrl;
    console.log("initialUrl", initialUrl);

    if (initialUrl.indexOf('/login') > 0) {
        initialUrl = AppConsts.appBaseUrl;
    }
      //alert(initialUrl);
      //location.href = initialUrl;


	  //Session içerisinden kullanıcının bilgilerini aldım.
	  //Amacımız ise default Url almaktı. Login sayfasına
	  //yönlendirilirken gideceği ilk url i belirlemiş olduk.
	  this._sessionService.getCurrentLoginInformations()
		  .subscribe(userInfo => {
			        //location.href = 'app/dashboard';

			  location.href = userInfo.user.userDefaultPageUrl;
			  
	  })
      //location.href = 'app/dashboard';
  }
  
    private clear(): void {
      this.authenticateModel = new AuthenticateModel();
      this.authenticateModel.rememberClient = false;
      this.authenticateResult = null;
      this.rememberMe = false;
    }
  
}
